const groupUsersList = () => import('@/views/main/groupUsers/list/List.vue')
export default {
  path: '/main/groupUsers/groupUsersList',
  name: 'groupUsersList',
  component: groupUsersList,
  children: []
}
